import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { Segment, Dimmer, Loader } from 'semantic-ui-react';
import { isEmpty } from 'lodash';

import { usePageData } from '../assets/hooks';
import { InnerBlocks, SemanticPlaceholder } from '../assets/components';

function Title({ ...rest }) {
  return <h1 {...rest}>{rest.children}</h1>;
}

export function Content({ request, ...rest }) {
  const [pageData, pageBlocks, loaded, error] = usePageData(request, 'default');
  const [message, setMessage] = useState(`Loading`);
  const { template, title } = pageData;

  const renderTitle = template === 'stories.php';

  const wrapClasses = classnames('wrap');

  const hasInnerBlocks = !isEmpty(pageBlocks);
  const dimmed = !loaded || !hasInnerBlocks;

  function updateScrollPosition(selector) {
    var element = document.querySelector(selector);

    // console.log(element);

    if (element) {
      const offset = 100;

      const { top } = element.getBoundingClientRect();
      const { scrollY } = window;

      // element.scrollIntoView();

      const rawPosition = top + scrollY;

      const position = rawPosition - offset;

      window.scrollTo({
        top: position,
        behavior: 'auto',
      });
    }
  }

  function tryScrollOnLoad() {
    const hash = window.location.hash;

    if (hash) {
      // console.log(`Hash found! ${hash}`);

      updateScrollPosition(hash);
    } else {
      window.scrollTo(0, 0);
    }
  }

  function handleHashLinks() {
    const links = document.querySelectorAll('#root a');

    links.forEach(link => {
      const worker = event => {
        // console.log(`I'm here #1`);

        const { target } = event;
        const { pathname } = window.location;

        const targetUrl = new URL(target.href);
        const targetPath = targetUrl.pathname;
        const hash = targetUrl.hash;

        if (pathname !== targetPath) return;

        // console.log(`I'm here #2`);

        if (hash) {
          event.preventDefault();
          updateScrollPosition(hash);

          // console.log(`I'm here #3`);
        }
      };

      link.removeEventListener('click', worker);
      link.addEventListener('click', worker, { once: true });
    });
  }

  useEffect(() => {
    tryScrollOnLoad();
    handleHashLinks();
  });

  // console.log(`Loaded -> ${loaded}`);
  // console.log(`Error -> ${error}`);
  // console.log(`Message -> ${message}`);
  // console.log(`Dimmed -> ${dimmed}`);
  // console.log(`Page blocks -> ${hasInnerBlocks}`);
  // console.log(pageBlocks);

  useEffect(() => {
    if (error) {
      setMessage(`Something went wrong :(`);
      return;
    }

    if (loaded && hasInnerBlocks) {
      setMessage(`Loaded`);
      return;
    }
  }, [error, loaded, hasInnerBlocks]);

  return (
    <Dimmer.Dimmable className={wrapClasses} as={Segment} dimmed={dimmed} basic blurring>
      <Dimmer active={dimmed} inverted>
        <Loader>{message}</Loader>
      </Dimmer>

      {!hasInnerBlocks ? (
        <SemanticPlaceholder repeat={5} />
      ) : (
        <InnerBlocks blocks={pageBlocks} nowrap>
          {renderTitle && <Title className="page-title">{title.rendered}</Title>}
        </InnerBlocks>
      )}
    </Dimmer.Dimmable>
  );
}
